import { useCallback, useLayoutEffect, useState } from "react";
var DROPDOWN_OFFSET_PX = 6;
var MIN_RIGHT_PX = 8;
function buildDropdownStyle(trigger) {
    var _a, _b;
    if (!trigger)
        return null;
    var rect = trigger.getBoundingClientRect();
    var viewportWidth = (_b = (_a = window.visualViewport) === null || _a === void 0 ? void 0 : _a.width) !== null && _b !== void 0 ? _b : window.innerWidth;
    return {
        top: "".concat(Math.round(rect.bottom + DROPDOWN_OFFSET_PX), "px"),
        right: "".concat(Math.max(MIN_RIGHT_PX, Math.round(viewportWidth - rect.right)), "px"),
    };
}
export function useAnchoredDropdownPosition(triggerRef, isOpen) {
    var _a = useState({}), dropdownStyle = _a[0], setDropdownStyle = _a[1];
    var updatePosition = useCallback(function () {
        var nextStyle = buildDropdownStyle(triggerRef.current);
        if (nextStyle) {
            setDropdownStyle(nextStyle);
        }
    }, [triggerRef]);
    useLayoutEffect(function () {
        var _a, _b;
        if (!isOpen)
            return;
        var handleWindowUpdate = function () { return updatePosition(); };
        window.addEventListener("resize", handleWindowUpdate);
        window.addEventListener("scroll", handleWindowUpdate, true);
        // visualViewport events fire when the browser chrome resizes the visible area
        // (e.g. keyboard appears, URL bar collapses) on real mobile/tablet browsers.
        (_a = window.visualViewport) === null || _a === void 0 ? void 0 : _a.addEventListener("resize", handleWindowUpdate);
        (_b = window.visualViewport) === null || _b === void 0 ? void 0 : _b.addEventListener("scroll", handleWindowUpdate);
        return function () {
            var _a, _b;
            window.removeEventListener("resize", handleWindowUpdate);
            window.removeEventListener("scroll", handleWindowUpdate, true);
            (_a = window.visualViewport) === null || _a === void 0 ? void 0 : _a.removeEventListener("resize", handleWindowUpdate);
            (_b = window.visualViewport) === null || _b === void 0 ? void 0 : _b.removeEventListener("scroll", handleWindowUpdate);
        };
    }, [isOpen, updatePosition]);
    return { dropdownStyle: dropdownStyle, updatePosition: updatePosition };
}
